import { Component, Emit, Provide, Ref, Vue } from 'vue-property-decorator'
import { NotificationVariableResponse } from '@/modules/configurationModule/detail/notifications/models/common'
import { customNotificationTypeService } from '@/modules/configurationModule/detail/notifications/services/custom-notification-type.service'
import { NotificationTemplatesModalType } from '@/modules/configurationModule/detail/notifications/components/notification-templates-modal/notification-templates-modal.model'
import { customNotificationVariablesService } from '@/api/resources/customNotifications/customNotificationVariablesService'
import {
    initialNotificationPredefinedTemplatesModalState,
    NotificationPredefinedTemplatesModalState
} from '@/modules/configurationModule/detail/notifications/components/notification-predefined-templates-modal/notification-predefined-templates-modal.model'
import responsibilityService from '@/api/resources/responsibilityService'
import { personnelService } from '@/api/resources/personnelService'
import { CommonResponsibilityResponse } from '@/api/services/common/responsibility/common-responsibility.dto'
import { BModal } from 'bootstrap-vue'
import { PredefinedCustomNotificationResponse } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.dto'

@Component
export default class NotificationPredefinedTemplatesModal extends Vue {
    @Ref() readonly notificationPredefinedTemplatesModal!: BModal
    @Ref() readonly notificationBodyTextInput!: any
    @Provide() externalValidator = this.$validator
    @Emit()
    update(notificationTemplate: NotificationPredefinedTemplatesModalState): NotificationPredefinedTemplatesModalState {
        return {
            id: this.state.id,
            ...notificationTemplate
        }
    }
    @Emit()
    create(notificationTemplate: NotificationPredefinedTemplatesModalState): NotificationPredefinedTemplatesModalState {
        return notificationTemplate
    }

    state: NotificationPredefinedTemplatesModalState
    constructor() {
        super()
        this.state = initialNotificationPredefinedTemplatesModalState()
    }

    get actionTitle(): string {
        return this.state.id ? this.$t('configuration.actions.update').toString()
            : this.$t('configuration.actions.add').toString()
    }

    async show(selectedRow: PredefinedCustomNotificationResponse | null): Promise<void> {
        await this.initializeNotificationTemplate(selectedRow)
        this._showModal()
    }

    async onTemplateTypeSelect(templateType: NotificationVariableResponse): Promise<void> {
        this.state.customNotificationVariables = await this.getAllCustomNotificationAllowedVariables(templateType.code)
    }

    onBodyAllowedVariablesBadgeClick(allowedVariable: string): void {
        const variable = `{{${allowedVariable}}}`
        this.notificationBodyTextInput.insertTextAtCaretPosition(variable)
        this.$nextTick(() => {
            this.notificationBodyTextInput.focus()
        })
    }

    onSubjectAllowedVariablesBadgeClick(allowedVariable: string): void {
        this.state.subject += `{{${allowedVariable}}}`
    }

    async initializeNotificationTemplate(notificationPredefinedTemplate: PredefinedCustomNotificationResponse | null): Promise<void> {
        this.state = initialNotificationPredefinedTemplatesModalState()
        await this.$validator.reset()
        if (notificationPredefinedTemplate) {
            const customNotificationVariables = await this.getAllCustomNotificationAllowedVariables(notificationPredefinedTemplate.type.code)
            this.state = {
                customNotificationVariables,
                id: notificationPredefinedTemplate.id,
                active: notificationPredefinedTemplate.active,
                title: notificationPredefinedTemplate.title,
                subject: notificationPredefinedTemplate.subject,
                body: notificationPredefinedTemplate.body,
                personnelToBeNotifiedList: notificationPredefinedTemplate.personnelToBeNotifiedList,
                responsibilitiesToNotify: notificationPredefinedTemplate.responsibilitiesToNotify,
                laboratory: notificationPredefinedTemplate.laboratory,
                attachReport: notificationPredefinedTemplate.attachReport,
                shouldNotifyDepartment: notificationPredefinedTemplate.shouldNotifyDepartment,
                shouldNotifyPetitioner: notificationPredefinedTemplate.shouldNotifyPetitioner,
                type: notificationPredefinedTemplate.type
            }
        }
    }

    get templateTypeSelectDisabled(): boolean {
        return !!this.state.id
    }

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    async getAllCustomNotificationAllowedVariables(code: string): Promise<NotificationVariableResponse[]> {
        const response =
            await this.$_toCallSecure(
                customNotificationVariablesService.getAllCustomNotificationVariablesByNotificationType(code))
        return response ?? []
    }
    async getAllCustomNotificationTypes(): Promise<NotificationTemplatesModalType[]> {
        const response =
            await this.$_toCallSecure(
                customNotificationTypeService.getCustomNotificationTypes())
        return response ?? []
    }

    async loadResponsibilities() {
        return responsibilityService.findAllResponsibilitiesByLaboratory(this.laboratoryId)
            .then(response => response.sort((a: CommonResponsibilityResponse, b: CommonResponsibilityResponse) => a.translatedName.localeCompare(b.translatedName)))
    }

    async getPersonnel() {
        return personnelService.getPersonnel(this.laboratoryId, null)
    }

    actionModal(): void {
        if (this.state?.id) {
            this.update(this.state)
        } else {
            this.create(this.state)
        }
    }

    private _showModal(): void {
        this.notificationPredefinedTemplatesModal.show()
    }

    hide(): void {
        this.notificationPredefinedTemplatesModal.hide()
    }
}
